import * as React from "react"
import {Box, Divider, Typography} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";

import {usePricingDiscountRoleConfig} from "../../../@hooks";
import DetailsButton from "./DetailsButton";


export default function PricingCandlestickTooltipBody({ discount, numSkus, groupedID, externalSeller, onCloseTooltip }) {
	const { typeKpi } = usePricingDiscountRoleConfig()

	return <Box sx={{ overflowY: 'auto', maxHeight: 450 }}>
		<Typography sx={{ display: 'flex', fontWeight: 'bold', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
			{formatPercentage(discount)} {typeKpi}
			<Typography>
				<DetailsButton discount={discount} groupedID={groupedID} externalSeller={externalSeller} onCloseTooltip={onCloseTooltip} />
			</Typography>
		</Typography>
		<Divider />
		<Box sx={{ pt: .5 }}>
			<Typography variant="h6" sx={{ color: 'text.disabled', py: 1 }}>
				{numSkus} Products
			</Typography>
		</Box>
	</Box>
}